module.exports = __webpack_public_path__ + "static/media/wa-white.6376f33d.svg";